<div class="lead-conversion-metrics">
    @if (isLoading()) {
        <div class="lead-conversion-metrics__loading">
            @for (skeleton of skeletonItems; track skeleton) {
                <div class="metric-card metric-card--skeleton">
                    <div class="metric-card__value-skeleton"></div>
                    <div class="metric-card__label-skeleton"></div>
                    <div class="metric-card__subtitle-skeleton"></div>
                </div>
            }
        </div>
    } @else if (error()) {
        <div class="lead-conversion-metrics__error">
            <p class="lead-conversion-metrics__error-text">{{ error() }}</p>
        </div>
    } @else {
        <div class="lead-conversion-metrics__cards">
            <!-- Card 1: Lead Conversion Ratio -->
            <div class="metric-card metric-card--ratio">
                <button
                    class="metric-card__info"
                    [eiTooltip]="getTooltipText('ratio')"
                    eiTooltipPosition="top"
                    aria-label="Info"
                    type="button"
                >
                    <img [src]="infoIcon" alt="" class="metric-card__info-icon" />
                </button>
                <div class="metric-card__value metric-card__value--ratio">
                    {{ metrics().conversionRatio }}
                </div>
                <div class="metric-card__label">Lead Conversion Ratio</div>
                <div class="metric-card__subtitle">Unqualified Leads → Customer</div>
            </div>

            <!-- Card 2: Lead to Won % -->
            <div class="metric-card metric-card--percentage">
                <button
                    class="metric-card__info"
                    [eiTooltip]="getTooltipText('percentage')"
                    eiTooltipPosition="top"
                    aria-label="Info"
                    type="button"
                >
                    <img [src]="infoIcon" alt="" class="metric-card__info-icon" />
                </button>
                <div class="metric-card__value metric-card__value--percentage">
                    <div class="percentage-circle">
                        <span class="percentage-value">{{ metrics().leadToWonPercentage }}%</span>
                    </div>
                </div>
                <div class="metric-card__label">Lead to Won %</div>
            </div>

            <!-- Card 3: Leads Summary -->
            <div class="metric-card metric-card--summary">
                <div class="metric-card__summary-item">
                    <div class="metric-card__summary-label">Leads</div>
                    <div class="metric-card__summary-value metric-card__summary-value--leads">
                        {{ metrics().totalLeads }}
                    </div>
                </div>
                <div class="metric-card__summary-item">
                    <div class="metric-card__summary-label">Active Pipeline</div>
                    <div class="metric-card__summary-value metric-card__summary-value--pipeline">
                        {{ metrics().pipelineLeads }}
                    </div>
                </div>
                <div class="metric-card__summary-item">
                    <div class="metric-card__summary-label">Won</div>
                    <div class="metric-card__summary-value metric-card__summary-value--won">
                        {{ metrics().wonLeads }}
                    </div>
                </div>
            </div>
        </div>
    }
</div>
